'use client';

import GlassSurface from './GlassSurface';

export default function NavGlassShell({ children }: { children: React.ReactNode }) {
  return (
    <GlassSurface data-component-id="src/components/ui/NavGlassShell.tsx:7:4" data-component-path="src/components/ui/NavGlassShell.tsx" data-component-line="7" data-component-end-line="22" data-component-file="NavGlassShell.tsx" data-component-name="GlassSurface" data-component-content="%7B%22elementName%22%3A%22GlassSurface%22%2C%22className%22%3A%22backdrop-blur-xl%20flex%20items-center%20px-3%22%7D"
      width="100%"
      height={44}
      borderRadius={28}
      blur={14}
      opacity={0.9}
      brightness={60}
      backgroundOpacity={0.15}
      distortionScale={-120}
      redOffset={5}
      greenOffset={10}
      blueOffset={20}
      className="backdrop-blur-xl flex items-center px-3"
    >
      <div data-component-id="src/components/ui/NavGlassShell.tsx:21:6" data-component-path="src/components/ui/NavGlassShell.tsx" data-component-line="21" data-component-end-line="21" data-component-file="NavGlassShell.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-full%20h-full%20gap-1.5%22%7D" className="flex items-center justify-center w-full h-full gap-1.5">{children}</div>
    </GlassSurface>
  );
}
